'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const intelligentFormat = require('dibs-currency-helpers/intelligentFormat');

const pinterestUtils = require('../../utils/social/pinterest');
const style = require('./ConnectAccountsModal-style.scss');

// Actions
const pinterestActions = require('../../actions/pinterestActions');

// Components
const ContextComponent = require('../ContextComponent');
const LogoNoRegIcon = require('dibs-vg/dist/react/logo-no-reg');
const HeartFilledIcon = require('dibs-vg/dist/react/heart-filled');
const ArrowRightIcon = require('dibs-vg/dist/react/arrow-right');
const PinterestIcon = require('dibs-vg/dist/react/pinterest');
const CloseIcon = require('dibs-vg/dist/react/close');
const Modal = require('../Modal');
const SanitizeHtml = require('../SanitizeHtml');

const ALLOWED_TAGS = ['br', 'a', 'span'];
const ALLOWED_ATTRIBUTES = {
    a: ['href', 'target', 'rel', 'title'],
    span: ['class']
};

class ConnectAccountsModal extends ContextComponent {

    constructor(props) {
        super(props);
        this.close = this.close.bind(this);
        this.openOath = this.openOath.bind(this);
    }

    openOath() {
        const {tracking} = this.props;
        const pinterestWindow = pinterestUtils.openWindow();
        this.context.executeAction(pinterestActions.track, tracking.connectClicked);
        this.context.executeAction(pinterestActions.connectAccounts, {
            pinterestWindow,
            tracking: tracking.connectSuccessful
        });
    }

    close(event) {
        event.preventDefault();
        this.context.executeAction(pinterestActions.hideConnectAccountsModal);
    }

    _getContent() {
        const {item} = this.props;

        if (item) {
            const {title, image, seller} = item || {};

            return (
                <div className={style.contentHolder}>
                    <div className={style.dibs}>
                        <LogoNoRegIcon className={style.dibsIcon} />
                        <img className={style.dibsImage} src={image} />
                        <div className={style.title}>{title}</div>
                        {this._getPrice()}
                        <div className={style.seller}>{seller}</div>
                        <HeartFilledIcon className={style.star} />
                        <ArrowRightIcon className={style.arrow} />
                    </div>

                    <div className={style.pinterest}>
                        <PinterestIcon className={style.pinterestIcon} />
                        <img className={style.pinterestImage} src={image} />
                        <div className={style.pinterestFooter}>from 1stdibs.com</div>
                    </div>
                </div>
            );
        }
    }

    _getPrice() {
        const {currency, item: {price}} = this.props;

        if (price) {
            return (
                <div className={style.price}>
                    {intelligentFormat(price, currency)}
                </div>
            );
        }
    }

    render() {
        const {copy} = this.props;

        return (
            <Modal isOpen={this.props.isOpen}
                className={style.modal}
                overlayClassName={style.overlay}
                canClose={false}>
                <div className={style.content}>
                    <a onClick={this.close} href="">
                        <CloseIcon className={style.close} />
                    </a>
                    <h2 className={style.header}>{copy.header}</h2>
                    <p className={style.description}>
                        <SanitizeHtml allowedTags={ALLOWED_TAGS}
                            allowedAttributes={ALLOWED_ATTRIBUTES}
                            content={copy.description} />
                    </p>

                    {this._getContent()}

                    <button onClick={this.openOath}
                        className={`${style.button} button-large button-primary`}>
                        {copy.cta}
                    </button>
                    <a onClick={this.close}
                        className={`${style.footerLink} italic`}
                        href="">
                        {copy.cancel}
                    </a>
                </div>
            </Modal>
        );
    }

}

ConnectAccountsModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    item: PropTypes.object,
    currency: PropTypes.string,
    copy: PropTypes.object.isRequired,
    tracking: PropTypes.object,
    style: PropTypes.shape({
        content: PropTypes.object,
        overlay: PropTypes.object
    })
};

module.exports = ConnectAccountsModal;



// WEBPACK FOOTER //
// ./assets/js/global/components/Pinterest/ConnectAccountsModal.jsx